import { Fab } from "@mui/material";
import IconButton from "components/Button/IconButton";

import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";

import { dateFormat } from "utils";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";
import {
    deleteSubject,
    getSubjects,
    updateSubjectStatus,
} from "services/subject/subjectController";
import Switch from "components/Switch/Switch";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import useDataTable from "hooks/useDataTable";
import SpeedDial from "components/speed-dial/SpeedDial";
import { useSearchParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import FormControl from '@mui/material/FormControl';
import { deleteinterviewStudent, getInterviewStudents } from "services/student/studentController";
import AddInterviewStudent from "./AddInterviewStudent";
import UpdateInterviewStudent from "./UpdateInterviewStudent";
const ViewInterviewStudents = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    let activePage = +searchParam.get("page") || 1;

    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);

    const [search, setSearch] = useState(searchParam.get("query") || "");
    const debounceValue = useDebounce(search || "", 300);

    const [blockModal, setBlockModal] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [selectedData, setSelectedData] = useState({});
    const [limit, setLimit] = useState(10);
    const [selectedId, setSelectedId] = useState("");
    const handleLimitChange = (event) => {
        const newLimit = parseInt(event.target.value, 10); // Parse the selected value to an integer
        setLimit(newLimit); // Update the limit state
        searchParam.set("limit", newLimit); // Update the limit parameter in the URL search params
        setSearchParam(searchParam); // Update the search params
        interviewStudentListing(activePage, debounceValue, newLimit); // Call the regionalList function with the new limit value
    };

    //**********subject Listing**********/
    const interviewStudentListing = async (page = activePage, search = debounceValue, pageLimit = limit) => {
        try {
            showLoader();
            const res = await getInterviewStudents({ page, search, limit: pageLimit });
            hideLoader();
            if (res.code === 200) {
                const { rows, count } = res.data.interviewstudents;
                setRecord(rows || []);
                setTotal(count || 0);
                setSelectedId("");
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };

    //********Reset Filter****** */
    const restFilter = () => {
        setSearch("");
    };


    // delete subject function
    const deleteInterviewStudent = async () => {
        try {
            setSubmitLoading(true);
            const res = await deleteinterviewStudent({
                id: selectedId,
            });
            if (res.code === 200) {
                interviewStudentListing();
                toast.success(res.message);
                setDeleteModal(false);
                setSubmitLoading(false);
                setSelectedId("");
            } else {
                toast.error(res.message);
                setSubmitLoading(false);
                setSelectedId("");
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
            setSelectedId("");
            setSubmitLoading(false);
        }
    };

    useEffect(() => {
        if (debounceValue) {
            searchParam.set("query", debounceValue);
        } else {
            searchParam.delete("query");
        }
        if (activePage === 1) {
            searchParam.delete("page");
        }
        setSearchParam(searchParam);
        interviewStudentListing(activePage, debounceValue, "");
        // eslint-disable-next-line
    }, [searchParam, debounceValue]);

    useEffect(() => {
        if (search) {
            searchParam.set("page", "");
        }
        // eslint-disable-next-line
    }, [search]);

    return (
        <React.Fragment>
            <title>Shubhra Viraj | Interview Students Management</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox">
                                <div className="div_wrap">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control"
                                        name="search"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                                <div className="div_no_wrap mx-3"></div>
                                {/* <div className="div_wrap2">
                                    <label htmlFor="rows-select" className="form-label-dp">
                                        No of rows:
                                    </label>
                                    <FormControl sx={{ m: 1, minWidth: 40 }} size="small">
                                        <select
                                            className="form-control-dp"
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={limit}
                                            onChange={handleLimitChange} // Call handleLimitChange when the value changes
                                        >
                                            {[10, 20, 40, 80, 100].map((num) => (
                                                <option value={num} key={num}>
                                                    {num}
                                                </option>
                                            ))}
                                        </select>
                                    </FormControl>
                                </div> */}
                                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>
                                <div>
                                    <Button onClick={() => setAddModal(true)}
                                        type="acl"
                                        role={130602}
                                    >Add Student</Button>
                                </div>
                            </div>
                            <h4 className="Title">Interview Students List</h4>
                        </div>
                        <div className="TableList overflow-auto table-responsive">
                            {loader}
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Student Name</th>
                                        <th>EmailID</th>
                                        <th>Mobile</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {record && record.length > 0 ? (
                                        record.map(({ id, firstname, lastname, email, mobile }, i) => (
                                            <tr key={i}>
                                                <td>{++i + (activePage - 1) * 10}</td>
                                                <td>{firstname + " " + lastname}</td>

                                                <td>{email}</td>
                                                <td>{mobile}</td>

                                                <td>
                                                    <div className="d-flex justify-content-center w-100">
                                                        <IconButton
                                                            className="px-1 py-0"
                                                            type="acl"
                                                            role={130603}
                                                            onClick={() => {
                                                                setSelectedData({
                                                                    id,
                                                                    firstname,
                                                                    lastname,
                                                                    email,
                                                                    mobile
                                                                });
                                                                setUpdateModal(true);
                                                            }}
                                                        >
                                                            <EditIcon sx={{ color: "#4971b2" }} />
                                                        </IconButton>

                                                        <IconButton
                                                            className="px-1 py-0"
                                                            type="acl"
                                                            role={130604}
                                                            onClick={() => {
                                                                setSelectedId(id);
                                                                setDeleteModal(true);
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ color: "#d32f2f" }} />
                                                        </IconButton>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <NotFound cols={12} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        {total > 10 ? (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {/* Delete Subject */}
            <ModalBox
                status={deleteModal}
                onClose={() => {
                    setDeleteModal(false);
                    setSelectedId("");
                }}

                title={"Delete Interview Student"}
                description={"Are you sure want to delete this student ?"}
                action={deleteInterviewStudent}
                customizedFooter={
                    <Button onClick={deleteInterviewStudent} {...submitButtonElement}>
                        Yes, Delete
                    </Button>
                }
            >

            </ModalBox>

            <AddInterviewStudent
                open={addModal}
                onClose={() => setAddModal(false)}
                interviewStudentListing={interviewStudentListing}
            />

            <UpdateInterviewStudent
                open={updateModal}
                onClose={() => setUpdateModal(false)}
                selectedData={selectedData}
                interviewStudentListing={interviewStudentListing}
            />


        </React.Fragment>
    );
};

export default ViewInterviewStudents;
